import { BASE_ADMIN_API_ROOT_PATH } from '../../shared/api/constants/path.constants';

export const ADMIN_SUB_CATEGORIES_API_ROOT = `${BASE_ADMIN_API_ROOT_PATH}/sub-categories`;

export const ADMIN_SUB_CATEGORIES_API_PATHS = {
  GET_SUB_CATEGORIES: `${ADMIN_SUB_CATEGORIES_API_ROOT}`,
  CREATE_SUB_CATEGORY: ADMIN_SUB_CATEGORIES_API_ROOT,
  UPDATE_SUB_CATEGORY: (subCategoryId: string) => `${ADMIN_SUB_CATEGORIES_API_ROOT}/${subCategoryId}`,
  ARCHIVE_SUB_CATEGORY: (subCategoryId: string) => `${ADMIN_SUB_CATEGORIES_API_ROOT}/${subCategoryId}`,
  RESTORE_SUB_CATEGORY: (subCategoryId: string) => `${ADMIN_SUB_CATEGORIES_API_ROOT}/${subCategoryId}/restore`,
  UPDATE_SUB_CATEGORIES_POSITIONS: `${ADMIN_SUB_CATEGORIES_API_ROOT}/positions`,
};
